import api from '../utilities/api';
import type { AuthTokens } from '../models/auth';
import { getRefreshToken } from '../utilities/storage/tokenStorage';

const ACT_AS_PATH = '/auth/act-as';
const LOGOUT_PATH = '/auth/logout';

/**
 * Demande une session accompagnée au serveur : la preuve de possession est le refresh
 * token COURANT (celui du Pro — l'overlay act-as est forcément inactif, garde dans
 * useActAsMode). `null` = refus (périmètre, type, établissement) ou échec réseau.
 */
export async function requestActAsTokens(beneficiaryId: string): Promise<AuthTokens | null> {
    const refreshToken = await getRefreshToken();
    if (!refreshToken) return null;
    try {
        const { data } = await api.post<AuthTokens>(ACT_AS_PATH, { beneficiaryId, refreshToken });
        return data;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('[ActAs] démarrage de session accompagnée refusé', error);
        return null;
    }
}

/** Révoque la session accompagnée (famille act-as seule, jamais celle du Pro). Best effort. */
export function revokeActAsSession(actAsRefreshToken: string): void {
    api.post(LOGOUT_PATH, { refreshToken: actAsRefreshToken }).catch(() => {});
}

/**
 * Ids des derniers bénéficiaires accompagnés du Pro courant (plus récent en premier).
 * À n'afficher qu'en INTERSECTION avec la liste de périmètre chargée fail closed
 * (décision 14) — jamais directement. `[]` sur échec : les récents sont un confort.
 */
export async function fetchRecentActAsBeneficiaryIds(limit: number): Promise<string[]> {
    if (limit <= 0) return [];
    try {
        const { data } = await api.get<{ beneficiaryIds: string[] }>(`${ACT_AS_PATH}/recent`, {
            params: { limit }
        });
        return data.beneficiaryIds ?? [];
    } catch {
        return [];
    }
}
